import React from 'react';

interface XIconProps {
  className?: string;
  variant?: 'filled' | 'stroked';
  strokeWidth?: number | string;
}

/**
 * X/close icon. Used for error states, close buttons, failed items, etc.
 */
export function XIcon({
  className = 'h-4 w-4',
  variant = 'filled',
  strokeWidth = 2,
}: XIconProps): React.ReactElement {
  if (variant === 'stroked') {
    return (
      <svg
        className={className}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    );
  }
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
      <path
        fillRule="evenodd"
        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
}
